import { Paper, PaperProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";
import Iconify from "../Iconify";

const RootStyle = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3, 3, 3, 7.5),
    position: "relative",
    "& p": {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.pxToRem(14),
        fontStyle: "italic",
        lineHeight: 1.7,
    },
}));

const IconStyle = styled(Iconify)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(3),
    left: theme.spacing(3),
}));

interface Props extends PaperProps {
    children: ReactNode;
}

export default function CardCaution({ children, ...other }: Props) {
    return (
        <RootStyle variant="caution" {...other}>
            <IconStyle icon="eva:alert-circle-fill" color="primary.main" fontSize={24} />
            {children}
        </RootStyle>
    );
}
